import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("be_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

// Log errors but rethrow so component try/catch still works
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status) {
      console.warn("[API]", err.response.status, err.config?.method?.toUpperCase(), err.config?.url);
    }
    return Promise.reject(err);
  }
);

// Suppress CRA dev overlay for axios errors (prevents scary stack-trace UI)
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (e) => {
    if (e.reason?.isAxiosError || e.reason?.name === "AxiosError") {
      e.preventDefault();
    }
  });
  window.addEventListener("error", (e) => {
    if (e.error?.isAxiosError || e.error?.name === "AxiosError") {
      e.preventDefault();
    }
  });
}

export default api;
